import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Call",
    component: () => import("../views/call/Form.vue"),
  },
  {
    path: "/cast/call",
    name: "Call",
    component: () => import("../views/call/Form.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
